/**
 * ウエストタウン福田306号室。提供された間取り図を基準にした1KのCG。
 *
 * 寸法の根拠: 管理物件の物件資料（共有フォルダ）に「1K・専有面積 21.45㎡」とあるので、それに合わせている。
 * 間取り図の比率（幅225px : 奥行670px、浴室ユニットを物差しにして約83px/m）から
 * 内法およそ 2.7m × 8.0m とした。
 * 図面には「洋室8.0帖」と書かれているが、その表記どおりだと専有面積が合わないため、資料の面積を優先した。
 */

const H = 2.45;
const W = 2.7; // 幅（バルコニー側から見た左右）
const L = 8.87; // 奥行（玄関〜バルコニー端）
const wall = (from, to, openings = [], mat = 'plaster') => ({ from, to, h: H, openings, mat });
const door = (a, w = 0.62, top = 2.05) => ({ a, w, top });
const win = (a, w, sill = 0.15, top = 2.2, fill = 'glass') => ({ a, w, sill, top, fill });

export default {
  id: 'westtown',
  ambient: 1.55,
  sun: 0.9,

  rooms: [
    { x: [0, W], z: [0, L], floor: 'stone', ceil: 'plaster', h: H, roof: 'roof', ceilThick: 0.16 },
    // 玄関土間とキッチンの通路
    { x: [0.06, 1.35], z: [0.07, 3.69], y: 0.01, thick: 0.02, floor: 'tileBeige' },
    // 右側の水回り: WC・浴室
    { x: [1.41, 2.64], z: [0.07, 1.89], y: 0.01, thick: 0.02, floor: 'tileLight' },
    { x: [1.41, 2.64], z: [1.96, 3.63], y: 0.01, thick: 0.02, floor: 'tileLight' },
    // クローゼット
    { x: [1.41, 2.64], z: [3.69, 4.5], y: 0.01, thick: 0.02, floor: 'walnut' },
    // 洋室
    { x: [0.06, 2.64], z: [3.75, 7.98], y: 0.01, thick: 0.02, floor: 'oakLight' },
    // バルコニー
    { x: [0.06, 2.64], z: [8.04, 8.8], y: 0.01, thick: 0.02, floor: 'tileGrey', roof: false },
  ],

  walls: [
    // 外周。玄関は北側（z=0）、バルコニーは南側。
    wall([0, 0], [W, 0], [door(0.56, 0.68)]),
    wall([0, 0], [0, 8.04]),
    wall([W, 0], [W, 8.04]),
    wall([0, 8.04], [W, 8.04], [win(0.44, 1.83, 0.05, 2.25)]),
    wall([0, L], [W, L]),
    wall([0, 8.04], [0, L]),
    wall([W, 8.04], [W, L]),

    // 左が玄関・キッチン、右がWC・浴室・クローゼット。
    wall([1.38, 0], [1.38, 3.72], [door(0.75, 0.63), door(2.17, 0.63)]),
    wall([1.38, 1.03], [W, 1.03], [door(0.12, 0.56)]),
    wall([1.38, 1.96], [W, 1.96], [door(0.1, 0.56)]),
    wall([1.38, 3.67], [W, 3.67]),
    wall([1.38, 4.54], [W, 4.54], [door(0.14, 0.99)]),
    wall([0, 3.72], [1.38, 3.72], [door(0.38, 0.65)]),
  ],

  furniture: [
    // 可動家具は置かず、図面に描かれた固定設備だけを配置する。
    { type: 'kitchen', x: 0.06, z: 2.35, len: 1.5, rot: 90 },
    { type: 'washer', x: 0.36, z: 1.17 },
    { type: 'toilet', x: 2.3, z: 1.45, rot: 90 },
    { type: 'bathtub', x: 2.05, z: 2.82, w: 1.28, d: 0.7, rot: 90 },
    { type: 'ac', x: 1.35, y: 2.08, z: 7.89 },
    { type: 'spotRail', x: 1.35, y: H, z: 5.91, len: 1.4 },
  ],

  lights: [
    { x: 0.71, y: 2.05, z: 2.09, intensity: 3.2, distance: 4 },
    { x: 2.03, y: 2.05, z: 1.43, intensity: 2.6, distance: 3 },
    { x: 2.03, y: 2.05, z: 2.87, intensity: 2.8, distance: 3 },
    { x: 1.35, y: 2.12, z: 5.39, intensity: 5.5, distance: 6 },
    { x: 1.35, y: 2.12, z: 7.13, intensity: 5.5, distance: 6 },
  ],
};
